document.addEventListener("DOMContentLoaded", function () {
  const videoBlocks = document.querySelectorAll(".wp-block-video");

  videoBlocks.forEach(function (block) {
    const video = block.querySelector("video");

    video.addEventListener("play", function () {
      block.classList.add("is-playing");
    });

    video.addEventListener("pause", function () {
      block.classList.remove("is-playing");
    });
  });
});
